import type React from 'react';

/**
 * ลูกศรเลื่อน+เลือกในกลุ่มปุ่ม role="radio" (แบบแผน WAI-ARIA radiogroup) — BUG-S2261-005
 *
 * ปุ่มเลือกสภาพ/สถานะ/ผลซ่อมถูกทำเป็น role="radio" แล้ว (S2257/S2259) screen reader จึงประกาศว่าเป็น
 * "ปุ่มตัวเลือก" และผู้ใช้คาดหวังให้ลูกศรเลือกได้ แต่เดิมลูกศรไม่ทำอะไรเลย
 * ใช้: <div role="radiogroup" onKeyDown={handleRadioGroupArrowKeys}> · เลือกด้วยการ click ปุ่ม
 * (ใช้ onClick เดิมของแต่ละปุ่ม ไม่ต้องรู้ state)
 */
export function handleRadioGroupArrowKeys(event: React.KeyboardEvent<HTMLElement>): void {
  const forward = event.key === 'ArrowDown' || event.key === 'ArrowRight';
  const backward = event.key === 'ArrowUp' || event.key === 'ArrowLeft';
  if (!forward && !backward) return;
  const radios = Array.from(
    event.currentTarget.querySelectorAll<HTMLElement>('[role="radio"]:not([disabled]):not([aria-disabled="true"])')
  );
  if (radios.length === 0) return;
  const current = radios.indexOf(document.activeElement as HTMLElement);
  const start = current >= 0
    ? current
    : radios.findIndex((r) => r.getAttribute('aria-checked') === 'true');
  const base = start >= 0 ? start : forward ? -1 : 0;
  const next = radios[(base + (forward ? 1 : -1) + radios.length) % radios.length];
  event.preventDefault();
  next.focus();
  next.click();
}
